const masterServicesActionTypes = {
  FETCH_MASTERSERVICES_LIST: 'FETCH_MASTERSERVICES_LIST',
  FETCH_MASTERSERVICES_LIST_SUCCESS: 'FETCH_MASTERSERVICES_LIST_SUCCESS',
  FETCH_MASTERSERVICES_LIST_FAIL: 'FETCH_MASTERSERVICES_LIST_FAIL',

  ADD_OR_EDIT_MASTER_SERVICE: 'ADD_OR_EDIT_MASTER_SERVICE',
  ADD_OR_EDIT_MASTER_SERVICE_SUCCESS: 'ADD_OR_EDIT_MASTER_SERVICE_SUCCESS',
  ADD_OR_EDIT_MASTER_SERVICE_FAIL: 'ADD_OR_EDIT_MASTER_SERVICE_FAIL',

  RESET_ADD_OR_EDIT_MASTER_SERVICE: 'RESET_ADD_OR_EDIT_MASTER_SERVICE',

  DELETE_MASTER_SERVICE: 'DELETE_MASTER_SERVICE',
  DELETE_MASTER_SERVICE_SUCCESS: 'DELETE_MASTER_SERVICE_SUCCESS',
  DELETE_MASTER_SERVICE_FAIL: 'DELETE_MASTER_SERVICE_FAIL',

  RESET_DELETE_MASTER_SERVICE: 'RESET_DELETE_MASTER_SERVICE',

  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
  FETCH_CATEGORIES_FAIL: 'FETCH_CATEGORIES_FAIL',
};

export default masterServicesActionTypes;
